import React from 'react';
import styled from 'styled-components';

import { Router } from './Router';
import { RouterType } from './types';

const Container = styled.div`
  background-color: ${({ theme }) => theme.background.standard};
  padding: 12px 24px;
  border-right: 1px solid ${({ theme }) => theme.line.light};
  min-width: 240px;
  max-width: 240px;
  height: calc(100vh - 61px - 24px);
  overflow-y: auto;
`;

interface Props {
  router: RouterType[];
  active: string | null;
  setActive: (val: string | null) => void;
}

export const SideNav: React.FC<Props> = ({ router, active, setActive }) => {
  return (
    <Container>
      {router.map((route, index) => (
        <Router key={index} name={route.name} active={active} setActive={setActive} links={route.links} />
      ))}
    </Container>
  );
};
